(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eclore-header"] && !Shopify.designMode) return;
  try {
    
function connectEcloreMenus(root){
 root.querySelectorAll('.en-header').forEach(header=>{
  if(header.dataset.menuReady)return;header.dataset.menuReady='true';
  const drawer=header.querySelector('.en-drawer'),open=header.querySelector('.en-open'),close=header.querySelector('.en-close');
  const parents=[...header.querySelectorAll('.en-parent')];
  const closeParents=except=>parents.forEach(d=>{if(d!==except)d.open=false});
  open.addEventListener('click',()=>{closeParents();drawer.showModal()});
  close.addEventListener('click',()=>drawer.close());
  drawer.addEventListener('click',e=>{if(e.target!==drawer)return;const r=drawer.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)drawer.close()});
  drawer.addEventListener('close',()=>open.focus());
  parents.forEach(d=>{
   d.querySelector('summary').addEventListener('click',e=>{if(e.detail>0&&d.open)e.preventDefault()});
   d.addEventListener('toggle',()=>{if(d.open)closeParents(d)});
   d.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'){closeParents(d);d.open=true}});
   d.addEventListener('keydown',e=>{if(e.key==='Escape'){d.open=false;d.querySelector('summary').focus();e.preventDefault()}});
   d.addEventListener('focusout',()=>{setTimeout(()=>{if(!d.contains(document.activeElement)&&!d.matches(':hover'))d.open=false},0)});
  });
  header.addEventListener('pointerleave',e=>{if(e.pointerType==='mouse'&&!header.contains(document.activeElement))closeParents()});
  document.addEventListener('click',e=>{if(!header.contains(e.target))closeParents()});
  window.matchMedia('(min-width:601px)').addEventListener('change',e=>{if(e.matches&&drawer.open)drawer.close();closeParents()});
 });
}
connectEcloreMenus(document);
document.addEventListener('shopify:section:load',()=>connectEcloreMenus(document));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:request', async (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      return; 
    }

    // Cancel default cart addition processing
    event.preventDefault();

    try {
      // Convert FormData to array format (expected by AddToCartFlyout)
      const formData = event.detail.form;
      const formDataArray = [];
      for (let [key, value] of formData.entries()) {
        formDataArray.push({ name: key, value: value });
      }

      const submitButton = document.querySelector('button[type="submit"], input[type="submit"]');
      
        const addToCartFlyout = new window.AddToCartFlyout(formDataArray, {
          atcButton: submitButton,
          settings: {
            moneyFormat: window.SHOP_MONEY_FORMAT
          }
        });

        // Wait for AddToCartFlyout completion and return actual response data
        const handleComplete = (completeEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.resolve(completeEvent.detail.responseData);
        };

        const handleError = (errorEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.reject(errorEvent.detail.error);
        };

        document.addEventListener('addToCartFlyout:complete', handleComplete);
        document.addEventListener('addToCartFlyout:error', handleError);

    } catch (error) {
      console.error('AddToCartFlyout error:', error);
      event.detail.reject(error);
    }
  });

  document.addEventListener('product-form:cart:navigate', (event) => {
    if (!window.CART_REDIRECTION_ENABLED) {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      window.location.href = window.Theme.routes.cart_url;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
